import { useEffect, useState } from 'react';

interface LoadingTextProps {
  messages: string[];
  className?: string;
  interval?: number;
}

const LoadingText: React.FC<LoadingTextProps> = ({ messages, className, interval = 2000 }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index >= messages.length - 1) {
      return;
    }

    const timer = setTimeout(() => setIndex(i => i + 1), interval);

    return (): void => clearTimeout(timer);
  }, [index, messages.length, interval]);

  return (
    <div role="status" aria-live="polite" className={className}>
      {messages[index]}
    </div>
  );
};

export default LoadingText;
